var _ = require('underscore');
require('../node_modules/blowup/lib/blowup.js');
const narikaCommon = require('./nr_common.js');
(function () {
    'use strict';

    if (typeof window.narika === 'undefined') {
        var narika = function () {
        };

        if (typeof exports !== 'undefined') {
            exports.narika = narika;
        }

        if (typeof window !== 'undefined') {
            window.narika = narika;
        } else if (typeof global !== 'undefined') {
            global.narika = narika;
        }
    }
    var narika = window.narika;
    if (typeof narika.page === 'undefined') {
        narika.page = function () {
        };
    }

    var TABLE_PRODUCT_DESCRIPTION_LENGTH = 115;

    var showProduct = function (result, params) {

        if (result == null || result.status != narika.common.SUCCESS || result.body == null) {
            console.log('cannot get data');
            return;
        }

        var templateElement = $('#narika_product_template');
        var templateHtml = templateElement.html();

        var product = result.body;

        // カタログページは、そのまま表示することになった
        // if (product.catalog_page != null && product.catalog_page.length > 0) {
        //     // スペースがあったら、改行の見せ方になる
        //     product.catalog_page_list = product.catalog_page.split(' ');
        //     for (var i = 0; i < product.catalog_page_list.length; i++) {
        //         // カンマ「,」があったら、スペースに変換
        //         product.catalog_page_list[i] = product.catalog_page_list[i].replace(/\,/g, ' ');
        //     }
        // }

        if (product.q_and_a != null && product.q_and_a.length > 0) {
            product.q_and_a = product.q_and_a.trim();
        }
        if (product.download != null && product.download.length > 0) {
            product.download = product.download.trim();
        }

        // video(youtube)のURLが、短縮系になっている場合があるので、それをiframeで埋め込みができるように変更する
        // http(s)://youtu.be/<video_id> になっているはず
        if (product.video != null) {
            for (var i = 0; i < product.video.length; i++) {
                var vItem = product.video[i];
                var vIndex = vItem.name.indexOf('://youtu.be/');
                if (vIndex != -1) {
                    vIndex += '://youtu.be/'.length;
                    var videoId = vItem.name.substring(vIndex);
                    vItem.name = 'https://www.youtube.com/embed/' + videoId + '?controle=0';
                }
            }
        }

        product.sciboxUrl = narika.definition.SCIBOX_PRODUCT_URL + product.product_id;

        product.tag = narika.common.trim(product.tag);

        // 価格を日本円フォーマットに
        if (product.tax_exclusive_price != null) {
            product.price_str = narika.common.formatJapaneseYen(product.tax_exclusive_price);
        } else if (product.price != null) {
            // 基本的にはここに来ないはず
            product.price_str = narika.common.formatJapaneseYen(product.price);
        } else {
            // 基本的にはここに来ないはず
            product.price_str = narika.common.formatJapaneseYen(0);
        }

        product.tab_all_visible = false; // 各タブ全てが存在しない場合は、section ごと描画を行わない様にする必要がある。その判断するためのflag。

        // 関連商品、別売品、補充部品は同じデータ構造、及びHTML構造なので、
        // アルゴリズムを共通化させる形でプログラミングをしている。
        var product_tab_list = [
            // 別売品
            {
                productList: product.optional_item,
                visible: false,
                checked: '',
                name: '別売品',
                tabId: 'tab1',
                panelId: 'panel1',
            },
            // 補充品
            {
                productList: product.spare_parts,
                visible: false,
                checked: '',
                name: '補充品',
                tabId: 'tab2',
                panelId: 'panel2'
            },
            // 関連商品
            {
                productList: product.related_equipment,
                visible: false,
                checked: '',
                name: '関連商品',
                tabId: 'tab3',
                panelId: 'panel3'
            },
        ];
        // 説明文からHTMLタグを削除し、かつ長すぎる場合は文章を短くする。
        // 価格を日本円のフォーマットに変更
        var checkedFlag = false;
        for (var index = 0; index < product_tab_list.length; index++) {
            var relatedProductList = product_tab_list[index].productList;
            if (relatedProductList != null && relatedProductList.length > 0) {
                product.tab_all_visible = true; // タブの中身があった
                product_tab_list[index].visible = true; // 中身があるので、タブ表示フラグをtrue
                if (checkedFlag == false) {
                    // タブのデフォルトチェック
                    product_tab_list[index].checked = 'checked=""';
                    checkedFlag = true;
                }
                for (var i = 0; i < relatedProductList.length; i++) {
                    var item = relatedProductList[i];
                    if (item.full_description != null && item.full_description.length > 0) {
                        var description = narika.common.removeHTMLTagAndNR(item.full_description);
                        description = description.trim();
                        description = narika.common.cutSentences(description, TABLE_PRODUCT_DESCRIPTION_LENGTH, '...');
                        item.description = description;
                    } else {
                        item.description = '';
                    }

                    if (item.tax_exclusive_price != null) {
                        var price = narika.common.formatJapaneseYen(item.tax_exclusive_price);
                        item.price_str = price;
                    } else if (item.price != null) {
                        // 基本的にはここには来ないはず
                        var price = narika.common.formatJapaneseYen(item.price);
                        item.price_str = price;
                    } else {
                        // 基本的にはここには来ないはず
                        item.price_str = '';
                    }

                    item.url = createProductUrl(item.product_id);
                    if (item.product_code != null && item.product_code.length > 0
                        && item.product_code.indexOf(' ') == -1) {
                        item.url = createProductUrlByCode(item.product_code);
                    }
                }
            }
        }
        product.product_tab_list = product_tab_list;

        // ベタな実装だが、
        // ・最初のタブに checked をつける
        // ・タブの中身に要素があるかどうかの判定
        // を行っている。
        product.q_and_a_tab_visible = false;
        product.video_tab_visible = false;
        product.download_tab_visible = false;
        product.q_and_a_tab_checked = '';
        product.video_tab_checked = '';
        product.download_tab_checked = '';
        if (product.q_and_a != null && product.q_and_a.length > 0) {
            product.q_and_a_tab_visible = true;
            if (checkedFlag == false) {
                product.q_and_a_tab_checked = 'checked=""';
                checkedFlag = true;
            }
            product.tab_all_visible = true;
        }
        if (product.video != null && product.video.length > 0) {
            product.video_tab_visible = true;
            if (checkedFlag == false) {
                product.video_tab_checked = 'checked=""';
                checkedFlag = true;
            }
            product.tab_all_visible = true;
        }
        if (product.download != null && product.download.length > 0) {
            product.download_tab_visible = true;
            if (checkedFlag == false) {
                product.download_tab_checked = 'checked=""';
                checkedFlag = true;
            }
            product.tab_all_visible = true;
        }

        // rest api の表組みのデータを、表示するためにデータ構造を変更する
        var productTableWhole = new Object(); // テーブル情報全体（行の配列となる）
        productTableWhole.catalogNoRow = new Object();

        if (product.table_product_list == null) {
            // 以下のパターンの時にこの部分が実行される。
            // ・商品グループに１つしか存在しなく、spec が存在していない
            // ・管理画面で商品を勝手に作ってしまった
            product.table_product_list = new Array(); // 空の配列

            // 自分自身の情報を追加
            var self_product = {
                new_flag_rika: null,
                order_rika: null,
                price: product.price,
                tax_exclusive_price: product.tax_exclusive_price,
                product_code: product.product_code != null ? product.product_code : '',
                product_id: product.product_id,
                self: true,
                specList: null,
            };
            product.table_product_list.push(self_product);
        }

        // カタログNo部分
        productTableWhole.catalogNoRow.title = 'Cat.No.'; // カタログNo. のタイトル名
        productTableWhole.catalogNoRow.dataList = new Array(); // カタログNo. の配列
        for (var i = 0; i < product.table_product_list.length; i++) {
            var tableProduct = product.table_product_list[i];
            productTableWhole.catalogNoRow.dataList.push(tableProduct.product_code);
        }

        // spec部分
        var productTableRow = null;
        productTableWhole.specRowList = new Array();
        for (var i = 0; i < product.table_product_list.length; i++) {
            var tableProduct = product.table_product_list[i];
            if (tableProduct.specList != null && tableProduct.specList.length > 0) {
                for (var j = 0; j < tableProduct.specList.length; j++) {
                    var spec = tableProduct.specList[j];
                    if (i == 0) {
                        productTableRow = new Object();
                        productTableWhole.specRowList.push(productTableRow);
                        productTableRow.title = spec.name;
                        productTableRow.dataList = new Array();
                    } else {
                        productTableRow = productTableWhole.specRowList[j];
                    }

                    productTableRow.dataList.push(spec.value);
                }
            }
        }

        // 価格部分
        productTableWhole.priceRow = new Object();
        productTableWhole.priceRow.title = '価格（税抜）';
        productTableWhole.priceRow.dataList = new Array(); // 価格 の配列
        for (var i = 0; i < product.table_product_list.length; i++) {
            var tableProduct = product.table_product_list[i];
            var price = null;
            if (tableProduct.tax_exclusive_price != null) {
                if (tableProduct.tax_exclusive_price == 0) {
                    price = '0';
                } else {
                    price = narika.common.formatJapaneseYen(tableProduct.tax_exclusive_price);
                }
            } else if (tableProduct.price != null) {
                // 基本的には来ない
                price = narika.common.formatJapaneseYen(tableProduct.price);
            }
            productTableWhole.priceRow.dataList.push(price);
        }

        // 現在商品のURL
        product.url = createProductUrl(product.product_id);
        if (product.product_code != null && product.product_code.length > 0
            && product.product_code.indexOf(' ') == -1) {
            product.url = createProductUrlByCode(product.product_code);
        }

        // PDF出力
        product.pdfUrl = narika.definition.GET_PRODUCT_PDF_URL + '?product_id=' + product.product_id;

        var productUrlList = new Array();
        // 表組みのどこの部分に<a>タグが来るかわからないので、productTableWhole とは別に
        // 商品へのリンク情報のデータを作成することとした。
        for (var i = 0; i < product.table_product_list.length; i++) {
            var productUrl = createProductUrl(product.table_product_list[i].product_id);
            if (product.table_product_list[i].product_code != null && product.table_product_list[i].product_code.length > 0) {
                productUrl = createProductUrlByCode(product.table_product_list[i].product_code);
            }
            productUrlList.push(productUrl);
        }

        var compiled = _.template(templateHtml);
        var html = compiled({
            'home_url': HOME_PAGE_URL,
            'search_url': SEARCH_PAGE_URL,
            'product': product,
            'tableProductList': productTableWhole,
            'productUrlList': productUrlList
        });

        PRODUCT_ID = product.product_id;

        $('#narika_show_product_area').append(html);

        registerEvent();
    }

    var registerEvent = function () {
        clickModalEvent();
        changeThumnailImageEvent();
        setTableProductWidthEvent();
        outputPdfButtonClick();
        zoomImageEvent();
    };

    /**
     * 拡大鏡の設定
     */
    var zoomImageEvent = function () {
        var imgTag = $(".narika_zoom");
        if (imgTag.length > 0) {
            imgTag.blowup({
                'width': 300,
                'height': 300,
                'scale': 1.8
            });
        }
    };

    var outputPdfButtonClick = function () {
        $('#output_pdf_button').on('click', function () {
            // Post通信でも正常に動くが、ユーザがリロードするとパラメタエラーの画面が出てしまい使い勝手が悪いので、採用しない
            var pdfUrl = narika.definition.GET_PRODUCT_PDF_URL;
            var params = {};
            params['productId'] = PRODUCT_ID;
            var newwin = window.open('', 'narika_pdf_window');
            narika.common.sendPost(pdfUrl, params, newwin);
        });
    };

    var PRODUCT_ID = null;

    var createProductUrl = function (productId) {
        var productUrl = PRODUCT_PAGE_URL + '?product_id=' + productId;
        return productUrl;
    };

    var createProductUrlByCode = function (productCode) {
        var productUrl = PRODUCT_PAGE_URL + 'detailed/' + productCode;
        return productUrl;
    };

    // ==========================================
    // 商品詳細ページサムネイル画像切り替え
    // ==========================================
    var changeThumnailImageEvent = function () {
        var $thum = $('.thum-images-area img');
        var $main = $('.main-image-area img');

        $thum.each(function () {
            var _this = $(this);
            _this.on('click', function () {
                console.log(_this.attr('src'));
                var src = _this.attr('src');
                $main.attr('src', src);
                zoomImageEvent();
            })
        })
    };

    // ==========================================
    // 製品詳細ページテーブル全体幅算出
    // ==========================================
    var setTableProductWidthEvent = function () {
        var $itemnum = $('.product-comparison-section-table-wrapper table tr:first-of-type td').length;
        var $itemwidth = 260;
        var $titlewidth = 120;
        var $whole_item_width = ($itemnum * $itemwidth) + $titlewidth;
        var $whole_item_width_sp = $whole_item_width / 2;
        var $table = $('.product-comparison-section-table-wrapper table');

        // pc時テーブルサイズ定義
        if (window.matchMedia("(min-width: 960px)").matches) {
            $table.css('width', $whole_item_width);
            // sp時テーブルサイズ定義
        } else {
            $table.css('width', $whole_item_width_sp);
        }
    };
    window.addEventListener('resize', setTableProductWidthEvent);

    // ==========================================
    // モーダル実装
    // 製品詳細ページ
    // ==========================================
    var clickModalEvent = function () {
        var $scrollPos;
        var $btn = $('.modal-btn');
        var $content = $('.modal-content');
        var $body = $('body');
        var $overlay = $('.modal-overlay');
        var $close_btn = $('.modal__close');
        var $submit_btn = $('#agent_pdf_form [name=submit]');

        $btn.on('click', function () {
            $scrollPos = $(window).scrollTop();
            $content.fadeIn();
            $body.addClass('modal-fixed').css({ top: -$scrollPos });
            return false;
        });
        $($overlay, $close_btn).on('click', function () {
            $content.fadeOut();
            $body.removeClass('modal-fixed').css({ top: 0 });
            $(window).scrollTop($scrollPos);
            return false;
        });

        var outputPdf = function () {
            $content.fadeOut();
            $body.removeClass('modal-fixed').css({ top: 0 });
            $(window).scrollTop($scrollPos);

            // PDF出力
            var pdfUrl = narika.definition.GET_PRODUCT_PDF_URL + '?product_id=' + PRODUCT_ID;

            var password = $('#agent_pdf_form [name=agent_code]').val();
            password = password.trim();
            if (password.length > 0) {
                password = encodeURIComponent(password.trim());
                pdfUrl = pdfUrl + '&agency_code=' + password;
            }
            var newwin = window.open('', 'narika_product_pdf');
            newwin.location.href = pdfUrl;
        };

        $submit_btn.on('click', function () {
            outputPdf();
            return false;
        });
        $('#agent_pdf_form input').on('keydown', function (e) {
            // 改行コードの判定
            if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
                // ここで outputPdf を呼ぶことも考えられるが、ポップアップブロックになるので、何もしない
                return false; // submit されて、ページが再表示しないように、falseを返す。
            } else {
                return true;
            }
        });
    };

    var callProductAPI = function () {
        var productId = null, productCode = null;

        // /product/detailed/<商品コード> のURLの場合
        var pathUrl = location.href.match(/^https?:\/{2,}.*?(\/.*)/)[1];
        var detailedPath = '/' + narika.definition.PRODUCT_WORDPRESS_SLAG_URL + '/detailed/';
        var detailedIndex = pathUrl.indexOf(detailedPath);
        if (detailedIndex >= 0) {
            productCode = pathUrl.substring(detailedIndex + detailedPath.length);
            var slash = productCode.indexOf('/');
            if (slash >= 0) {
                if (slash == productCode.length - 1) {
                    productCode = productCode.substring(0, slash);
                } else {
                    return; // ループ防止（WordPressのrewriteの設定と関係するかも）
                }
            }
        } else {
            productId = narika.common.getUrlGetParam('product_id');
        }

        var apiUrl = narika.definition.GET_PRODUCT_API_URL;
        var formParam = {};
        formParam['request_source'] = narika.definition.REQUEST_SOURCE_RIKA;

        if (productId != null) {
            formParam['product_id'] = productId;
        } else if (productCode != null) {
            formParam['product_code'] = productCode;
        } else {
            return;
        }

        narika.common.callRestApi(apiUrl, 'POST', formParam,
            showProduct, null, null);
    };

    var PRODUCT_PAGE_URL = null;
    var SEARCH_PAGE_URL = null;
    var HOME_PAGE_URL = null;
    $(function () { // ready
        if ($('#narika_show_product_area').length == 0) {
            // 該当ページで無ければ、何もしない。
            return;
        }

        // 本ページのURLを取得
        // detailed があったら、それ以降の部分を削除
        PRODUCT_PAGE_URL = location.href.replace(/\?.*$/, "");
        if (PRODUCT_PAGE_URL.indexOf('detailed/') > 0) {
            PRODUCT_PAGE_URL = PRODUCT_PAGE_URL.substring(0, PRODUCT_PAGE_URL.indexOf('detailed/'));
        }
        var slash = PRODUCT_PAGE_URL.slice(-1);
        if (slash != '/') {
            PRODUCT_PAGE_URL = PRODUCT_PAGE_URL + '/'; // 念の為、スラッシュ終わりで統一する
        }
        HOME_PAGE_URL = PRODUCT_PAGE_URL + '..';
        SEARCH_PAGE_URL = PRODUCT_PAGE_URL + '../search';

        callProductAPI();
    });

})();